import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { useAuth } from "./context/AuthContext"
import ProtectedRoute from "./components/layout/ProtectedRoute"
import { AdminRoute } from "./components/layout/AdminRoute"
import Header from "./components/layout/Header"
import Footer from "./components/layout/Footer"

import Landing from "./pages/Landing"
import Login from "./pages/Login"
import Register from "./pages/Register"
import Dashboard from "./pages/Dashboard"
import Admin from "./pages/Admin"
import Propuestas from "./pages/Propuestas"
import Consulta from "./pages/Consulta"
import Generador   from "./pages/Generador"
import Cotizador   from "./pages/Cotizador"

function App() {
  const { user, userData } = useAuth()

  return (
    <BrowserRouter>
      <Header />
      <main style={{ width:"100%", minHeight:0 }}>
      <Routes>
        {/* Públicas */}
        <Route path="/" element={<Landing />} />

        {/* Si ya está logueado, no puede volver a login/register */}
        <Route
          path="/login"
          element={user ? <Navigate to="/dashboard" /> : <Login />}
        />
        <Route
          path="/register"
          element={user ? <Navigate to="/dashboard" /> : <Register />}
        />

        {/* Cliente — requiere login */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Admin — requiere login + es_admin = true */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <Admin />
            </AdminRoute>
          }
        />

        <Route path="/generador" element={
          <ProtectedRoute requiredRole="vendedor">
            <Generador />
          </ProtectedRoute>
        } />

        <Route path="/cotizador" element={
          <ProtectedRoute requiredRole="vendedor">
            <Cotizador />
          </ProtectedRoute>
        } />
        

        <Route path="/propuestas" element={<Propuestas />} />
        <Route path="/consulta" element={<Consulta />} />

        {/* Cualquier ruta desconocida → inicio */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  )
}

export default App